export default "__VITE_ASSET__cJhnFb2p__"